import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { DialogService } from 'primeng/dynamicdialog';
import { InterceptorProviders } from './core/interceptors/interceptors';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from './shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

@NgModule({
  declarations: [
    AppComponent,
    ContentLayoutComponent,
    HeaderComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastModule
   ],
  providers: [
    MessageService,
    DialogService,
    provideHttpClient(withInterceptorsFromDi()),
    InterceptorProviders,
    providePrimeNG({
        theme: {
            preset: Lara,
            options: {
                darkModeSelector: '.my-app-dark'
            }
        }
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

